import React from "react";
import { Shield, Copy, Check } from "lucide-react";
import { useState } from "react";

const AuthSection = ({ data }) => {
  const [copied, setCopied] = useState(false);

  if (!data) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(data.headerExample);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div id="api-key-usage" className="scroll-mt-6">
      <div className="flex items-center gap-2 mb-1">
        <Shield size={18} className="text-[#048AAD]" />
        <h2 className="text-lg font-bold text-gray-900">{data.title}</h2>
      </div>
      <p className="text-sm text-gray-500 mb-5 leading-relaxed">{data.description}</p>

      <div className="mb-5">
        <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 block">Header Format</span>
        <div className="relative bg-[#0d1117] border border-gray-800 rounded-lg p-4 pr-10">
          <code className="text-[13px] text-white font-mono">{data.headerExample}</code>
          <button onClick={handleCopy} className="absolute top-3 right-3 p-1 rounded text-gray-400 hover:text-white transition-colors">
            {copied ? <Check size={13} className="text-green-400" /> : <Copy size={13} />}
          </button>
        </div>
      </div>

      <div className="space-y-2.5">
        {data.notes.map((note, i) => (
          <div key={i} className="flex gap-2.5 items-start">
            <div className="w-1.5 h-1.5 rounded-full bg-[#048AAD] mt-1.5 flex-shrink-0" />
            <p className="text-sm text-gray-600 leading-relaxed">{note}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-xl">
        <h4 className="text-sm font-semibold text-amber-800 mb-1">Security Reminder</h4>
        <p className="text-xs text-amber-700 leading-relaxed">
          Never expose your API key in client-side code, public repositories, or browser requests. 
          Always make API calls from your backend server. If a key is compromised, revoke it immediately 
          from the API Keys page and generate a new one.
        </p>
      </div>
    </div>
  );
};

export default AuthSection;
